import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputToggle from './InputToggle';
import { allMutations } from '../utils/data';
import steps from '../img/steps2.png';

const mutDefs = {
  rt: {
    label: 'Reverse Transcriptase (RT)'
  },
  pr: {
    label: 'Protease (PR)'
  },
  in: {
    label: 'Integrase (IN)'
  }
};

class ResistanceInput extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    setMutations: PropTypes.func.isRequired,
    mutations: PropTypes.object.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func
    })
  };

  constructor(props) {
    super(props);

    this.state = {
      error: ''
    };

    this.saveError = this.saveError.bind(this);
    this.submit = this.submit.bind(this);
  }

  saveError(error) {
    this.setState({
      error
    });
  }

  submit(e) {
    e && e.preventDefault();
    this.props.setMutations();
    this.props.history.push('/report');
  }

  render() {
    return (
      <div className="c-page">
        <div className="c-page__header">
          <div className="c-page__intro">
            <h1>Resistance Helper</h1>
            <p className="c-page__lead">How to use this tool</p>
            <p className="c-page__p">Enter mutations or select from the list below, then select Analyze to see inferred levels of resistance to the most common HIV drugs. <a className="c-page__link" href="">Learn more</a></p>
            <p className="c-page__p">You can also upload sequences (via text file) or enter them directly using the <a className="c-page__link" href="">FASTA format</a>. Current limit is 1000 sequences of 3000 nucleotides per sequence.</p>
          </div>
          <div className="c-page__steps">
            <img src={steps} alt="steps" />
          </div>
        </div>
        <form className="c-rtool" onSubmit={this.submit}>
          <div className="c-rtool__actions">
            <div className="c-tabs">
              <button className="c-button c-button--tab c-button--tab-active">Mutations</button>
              {/* <button className="c-button c-button--tab">Sequences</button> */}
            </div>
            <div className="c-button-group">
              <button onClick={this.props.reset} type="reset" className="c-button c-button--secondary">Reset</button>
              <button type="submit" className="c-button c-button--primary">Analyze</button>
            </div>
          </div>
          <div className="c-rtool__inputs">
            {Object.keys(allMutations).map((mutationKey, i) => {
              return (
                <div className="c-rtool__column" key={mutationKey}>
                  <h3>{mutDefs[mutationKey].label}</h3>

                  <div
                    className="c-rtool__textarea"
                    onClick={() => { alert('For this demo, please use the checkboxes. In the future you will be able to use the textarea for input.'); }}
                  >
                    {Object.keys(this.props.mutations[mutationKey])
                      .filter(k => this.props.mutations[mutationKey][k])
                      .map((selected) => {
                        return (
                          <strong className="c-rtool__selected" key={selected}>{selected}</strong>
                        );
                      })}
                  </div>

                  <table className={`c-rtool__table ${i === 1 && 'c-rtool__table--alt'}`}>
                    <tbody>
                      {Object.keys(allMutations[mutationKey]).sort((a, b) => a - b).map((k) => {
                        return (
                          <tr className="c-rtool__tr" key={k}>
                            <td>{k}</td>
                            <td>
                              <div className="c-rtool__checkboxes">
                                {allMutations[mutationKey][k].options.map((opt) => {
                                  const val = `${allMutations[mutationKey][k].cons}${opt.value}`;
                                  return (
                                    <span className="c-rtool__checkbox c-checkbox" key={opt.value}>
                                      <input
                                        className="c-checkbox__input"
                                        type="checkbox"
                                        name={val}
                                        checked={!!this.props.mutations[mutationKey][val]}
                                        onChange={this.props.handleCheckboxChange(mutationKey, val)}
                                        id={`${mutationKey}-${val}`}
                                      />
                                      <label className="c-checkbox__label" htmlFor={`${mutationKey}-${val}`}>
                                        {opt.label !== '*' ?
                                          <span>{opt.label}</span> :
                                          <InputToggle isChecked={!!this.props.mutations[mutationKey][val]} />}
                                      </label>
                                    </span>
                                  );
                                })}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        </form>
      </div>
    );
  }
}

export default ResistanceInput;



// WEBPACK FOOTER //
// ./src/components/ResistanceInput.js